import type { TimelineEntry } from '@/mocks/dramas';
import { TIMELINE_META } from '@/utils/drama';

interface TimelineProps {
  entries: TimelineEntry[];
}

export default function Timeline({ entries }: TimelineProps) {
  return (
    <ol className="relative">
      {entries.map((entry, index) => {
        const meta = TIMELINE_META[entry.type];
        const isLast = index === entries.length - 1;
        return (
          <li
            key={`${entry.date}-${index}`}
            id={`timeline-node-${index}`}
            className="relative scroll-mt-28 pl-10 md:pl-14"
          >
            <span
              className={`absolute left-[13px] top-2 z-10 flex h-4 w-4 items-center justify-center rounded-full ring-4 ring-background-50 md:left-[21px] ${meta.dotClass}`}
            ></span>
            {!isLast && (
              <span className="absolute left-[20px] top-6 h-full w-px bg-background-300 md:left-[28px]"></span>
            )}

            <div className="pb-9">
              <div className="flex flex-wrap items-center gap-2">
                <time className="font-heading text-sm font-semibold text-foreground-900">
                  {entry.date}
                </time>
                <span
                  className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-medium ${meta.badgeClass}`}
                >
                  <i className={`${meta.icon} text-sm`}></i>
                  {meta.label}
                </span>
              </div>

              <h3 className="mt-3 font-heading text-base font-semibold text-foreground-950 md:text-lg">
                {entry.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{entry.content}</p>
            </div>
          </li>
        );
      })}
    </ol>
  );
}